import * as React from "react";

import GenPanelHeader from "../../Gen/PanelHeader";
import GenButton from "../../Gen/Button";

interface AddToSummaryProps {
  enabled: boolean
  categoryId?: number
  documentId: number
  documentSet: DocumentSetSnakeModel
  includesDoc: boolean
}

export default function AddToSummary(props: AddToSummaryProps) {
  const {
    enabled,
    categoryId,
    documentId,
    documentSet,
    includesDoc,
  } = props;

  const [canAdd, setCanAdd] = React.useState(!includesDoc);

  const onAddClicked = () => {
    if (!documentId) {
      return;
    }

    setCanAdd(false);

    const data = {
      documentIds: [documentId],
      event: "add_to_course_button",
      categoryId: categoryId,
    };

    fetch(`/document_sets/${documentSet.id}/document_set_document_relations/create_batch_list`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(() => {})
      .catch(() => {});
  };

  const onRemoveClicked = () => {
    if (!documentId) {
      return;
    }

    setCanAdd(true);

    const data = {
      documentIds: [documentId],
      event: "add_to_course_button",
      categoryId: categoryId,
    };

    fetch(`/document_sets/${documentSet.id}/document_set_document_relations/destroy_batch_list`, {
      method: "DELETE",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(() => {})
      .catch(() => {});
  };

  let button;
  const buttonIcon = canAdd ? "fa-plus" : "fa-minus";

  if (!enabled) {
    button = <GenButton name={<i title="You don't have permission to edit this course" className={`fa ${buttonIcon}`} />} disabled/>;
  } else if (canAdd) {
    button = <GenButton name={<i title="Add to course" className={`fa ${buttonIcon}`} />} highlighted onClick={onAddClicked}/>;
  } else {
    button = <GenButton name={<i title="Remove from course" className={`fa ${buttonIcon}`} />} destructive onClick={onRemoveClicked}/>;
  }

  return(
    <div className="panel summary">
      <GenPanelHeader rightContent={button}>
        <a
          target="_blank"
          href={`/document_sets/${documentSet.id}`}
          className="name" rel="noreferrer"
        >
          {documentSet.name}
        </a>
      </GenPanelHeader>

      <p className="description">{documentSet.description}</p>
      {documentSet.owner_full_name && <p> <strong> Course Owner: </strong> {documentSet.owner_full_name}</p>}
    </div>
  );
}
